import React from "react";
import Logo from "../components/Logo";
import Navigation from "../components/Navigation";

const About = () => {
  return (
    <div>
      <Navigation />
      <Logo />
      <h1>A propos</h1>
      <br />
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. At voluptate
        aliquid libero aspernatur earum non itaque nostrum, distinctio eveniet
        sunt architecto deleniti, porro voluptatem illum eligendi temporibus
        autem doloribus nulla ducimus hic corporis deserunt facilis aliquam.
        Iusto, saepe earum, temporibus recusandae enim aut minus dignissimos
        eius soluta officia alias repellendus. Ratione adipisci dolores aliquam
        praesentium maxime sapiente repellendus dignissimos qui natus molestiae
        exercitationem pariatur, doloribus, magnam error quae, blanditiis sequi?
        Dolorem soluta ad asperiores laboriosam, maiores atque tempora aut
        tempore?
      </p>
      <br />
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. At voluptate
        aliquid libero aspernatur earum non itaque nostrum, distinctio eveniet
        sunt architecto deleniti, porro voluptatem illum eligendi temporibus
        autem doloribus nulla ducimus hic corporis deserunt facilis aliquam.
        Iusto, saepe earum, temporibus recusandae enim aut minus dignissimos
        eius soluta officia alias repellendus. Ratione adipisci dolores aliquam
        praesentium maxime sapiente repellendus dignissimos qui natus molestiae
        exercitationem pariatur, doloribus, magnam error quae, blanditiis sequi?
        Dolorem soluta ad asperiores laboriosam, maiores atque tempora aut
        tempore?
      </p>
    </div>
  );
};

export default About;
